import React, { Component } from 'react';
import { Spinner } from '@riotgames/accounts-react-components';
import AppContext from '../../AppContext';
import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import './accountCreation.scss';

class AccountCreation extends Component {
  static contextType = AppContext;

  componentDidMount() {
    this.registerAccount();
  }

  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  availableAccount = async () => {
    const {
      actions: { availableUserName },
      state: { username }
    } = this.context;

    try {
      const res = await availableUserName(username);

      return res.status === 200;
    } catch ({ response }) {
      const { status } = response;

      // TODO : error handling
      let availableMsg;
      if (status === 409) {
        availableMsg = `"${username}"은 이미 사용중인 아이디입니다.`;
      } else if (status === 429) {
        availableMsg = '전광석화와 같이 확인하셨네요. 한 박자 쉬었다가!';
      } else {
        availableMsg = '서버와의 통신중 오류가 발생되었습니다.';
      }

      this.update({
        hasError: true,
        errorDetail: availableMsg,
        backToComponent: 'IdPasswd'
      });
    }
  };

  createAccount = async () => {
    const {
      actions: { createAccount, promoteAccount },
      state: { signupType, username, password, email, parentEmail, playerAuthInfo, parentAuthInfo, marketingAgreement }
    } = this.context;

    const apiAccount = signupType === 'PROMOTION' ? promoteAccount : createAccount;

    try {
      const res = await apiAccount({
        username,
        password,
        email,
        parentEmail,
        playerAuthInfo,
        parentAuthInfo,
        marketingAgreement
      });

      return res;
    } catch (e) {
      this.update({
        hasError: true,
        shouldReset: true,
        errorHeader: '오류',
        errorDetail: '인증 유효 시간이 지났습니다. 동의 및 본인인증을 다시 완료해주세요.'
      });
    }
  };

  // Register Account
  // 1. AvailableUsername
  // 2. Try createAccount
  // 3. Response check
  registerAccount = async () => {
    const isAvailableAccount = await this.availableAccount();
    if (!isAvailableAccount) {
      return false;
    }

    const res = await this.createAccount();
    if (!res) {
      return false;
    }

    this.resultRegist(res);
  };

  resultRegist = (res) => {
    let errMsg;

    if (res.status === 200 || res.status === 201) {
      this.moveNext();
      return;
    }

    if (res.status === 408 || res.status === 403) {
      errMsg = '인증 유효 시간이 지났습니다. 동의 및 본인인증을 다시 완료해주세요.';
    } else if (res.status === 406) {
      errMsg = '리그 오브 레전드는 최대 5개까지 계정 생성이 가능합니다.';
    } else {
      errMsg = `서버와의 처리 과정에서 오류가 발생하였습니다. 오류코드(${res.status})`;
    }

    this.update({
      hasError: true,
      shouldReset: true,
      errorHeader: '오류',
      errorDetail: errMsg
    });
  };

  async moveNext() {
    const {
      actions: { resetState },
      state: { username, signupType, step, flows, theme, pageTitle, footer, contentFooter }
    } = this.context;
    const exceptionData = {
      username,
      signupType,
      step,
      flows,
      theme,
      pageTitle,
      footer,
      contentFooter
    };

    await resetState(exceptionData);

    this.props.handleMoveNext();
  }

  render() {
    const {
      state: { signupType }
    } = this.context;

    const titleGridPanel = signupType === 'PROMOTION' ? '업그레이드' : '계정 생성';

    return (
      <GridPanel title={titleGridPanel}>
        <Grid direction={GridDirection.vertical} align={GridAlignment.center} justify={GridJustify.center} fill={true}>
          <Spinner />
        </Grid>
      </GridPanel>
    );
  }
}

export default AccountCreation;
